import { ChakraProvider } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import theme from '../../../theme'

export function AppThemeProvider({ children }: { children: ReactNode }) {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>
}
